/**
 * Descripción legible de un dispositivo a partir de su User-Agent, para la lista de
 * sesiones. Es orientativa: el User-Agent se puede falsear o recortar.
 */
export interface DeviceInfo {
  browser: string | null;
  os: string | null;
}

const BROWSERS: [RegExp, string][] = [
  [/EdgiOS|EdgA?\//, 'Edge'],
  [/SamsungBrowser\//, 'Samsung Internet'],
  [/OPR\/|Opera/, 'Opera'],
  [/FxiOS|Firefox\//, 'Firefox'],
  [/CriOS|Chrome\//, 'Chrome'],
  [/Version\/[\d.]+.*Safari\//, 'Safari'],
];

const SYSTEMS: [RegExp, string][] = [
  [/iPhone/, 'iPhone'],
  [/iPad/, 'iPad'],
  [/Android/, 'Android'],
  [/Windows NT/, 'Windows'],
  [/CrOS/, 'ChromeOS'],
  [/Mac OS X|Macintosh/, 'macOS'],
  [/Linux/, 'Linux'],
];

export function describeUserAgent(ua: string | null | undefined): DeviceInfo {
  if (!ua) return { browser: null, os: null };
  const browser = BROWSERS.find(([re]) => re.test(ua))?.[1] ?? null;
  const os = SYSTEMS.find(([re]) => re.test(ua))?.[1] ?? null;
  return { browser, os };
}
